import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify"; // Assuming toast is used in project
import { BarLoader } from "react-spinners"; // Assuming BarLoader is used

const BuyDM = ({ isModalOpen, setIsModalOpen, selectedUser }) => {
  const [paymentMethod, setPaymentMethod] = useState("paypal"); // 'paypal' or 'card'
  const [amount, setAmount] = useState("10.00");
  const [note, setNote] = useState("");
  const [cardDetails, setCardDetails] = useState({
    name: "",
    cardNumber: "",
    expiry: "",
    cvv: "",
  });
  const [loading, setLoading] = useState(false);
  const userToken = localStorage.getItem("userToken");

  // Construct API URL based on existing env logic (assuming REACT_APP_LOCAL_API points to /v1/auth or similar)
  // We need to reach /v2/payment/buy
  const getPaymentUrl = () => {
    const baseUrl = process.env.REACT_APP_LOCAL_API
      ? process.env.REACT_APP_LOCAL_API.split("/auth")[0] // robust split
      : "http://localhost:5000";

    // If split failed or structure is different, fallback or adjusting
    if (process.env.REACT_APP_LOCAL_API && !process.env.REACT_APP_LOCAL_API.includes("/auth")) {
      // incase it is just localhost:5000/api
      return `${process.env.REACT_APP_LOCAL_API}/../v2/payment/buy`;
    }

    return `${baseUrl}/v2/payment/buy`;
  };


  useEffect(() => {
    if (isModalOpen && paymentMethod === "paypal") {
      // Load PayPal SDK dynamically only if PayPal is selected
      const scriptId = "paypal-sdk-script";
      if (document.getElementById(scriptId)) {
        // re-render if needed
        renderPayPalButtons();
        return;
      }

      const script = document.createElement("script");
      script.id = scriptId;
      // Must be the same PayPal app the backend uses to create orders.
      const paypalClientId =
        process.env.REACT_APP_PAYPAL_CLIENT_ID ||
        "BAAuNoo7XD3cjJghsvL2XaMcKB0M0ZzfCDIr-qZqINiPGfi0cp7nQsy8DNiV7zfV_fzz5ZHuOlgY2qtt-I";
      script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&components=buttons&enable-funding=venmo&currency=USD`;
      script.async = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);

      script.onload = () => {
        renderPayPalButtons();
      };

      // Cleanup not strictly necessary here as we might toggle back, but good practice if modal closes
      return () => {
        // don't remove script to cache it
      };
    }
  }, [isModalOpen, paymentMethod, amount]); // Re-run if amount changes for PayPal order creation

  const renderPayPalButtons = () => {
    if (window.paypal) {
      const container = document.getElementById("paypal-container-2B2FXPQHQV2HQ");
      if (container) container.innerHTML = ""; // Clear previous buttons

      window.paypal.Buttons({
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: amount || "10.00",
                },
              },
            ],
          });
        },
        onApprove: function (data, actions) {
          return actions.order.capture().then(function (details) {
            alert("Transaction completed by " + details.payer.name.given_name);
            setIsModalOpen(false);
          });
        },
        onError: (err) => {
          console.error("PayPal Button Error:", err);
        },
      }).render("#paypal-container-2B2FXPQHQV2HQ");
    }
  }

  const handleCardSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!selectedUser?._id) {
      alert("Organization not identified.");
      setLoading(false);
      return;
    }

    // Format Expiry Date from MM/YY or MM/YYYY to YYYY-MM
    let formattedExpiry = "";
    try {
      const parts = cardDetails.expiry.includes("/") ? cardDetails.expiry.split("/") : [];
      if (parts.length === 2) {
        let month = parts[0].trim();
        let year = parts[1].trim();
        if (year.length === 2) year = "20" + year; // Handle YY
        formattedExpiry = `${year}-${month}`;
      } else {
        // Fallback or let backend fail, but better to warn
        throw new Error("Invalid format");
      }
    } catch (err) {
      alert("Please enter expiry in MM/YYYY format.");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        paymentMethod: "card",
        organizationName: selectedUser._id, // Backend expects organization ID in this field
        amount: parseFloat(amount),
        cardDetails: {
          name: cardDetails.name,
          cardNumber: cardDetails.cardNumber,
          cvv: cardDetails.cvv
        },
        expiry: formattedExpiry,
        note: note,
        return_url: "http://localhost:3000/dashboard", // Dummy URLs required by backend validation
        cancel_url: "http://localhost:3000/dashboard"
      };

      const config = {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      };

      const url = getPaymentUrl();
      const response = await axios.post(url, payload, config);

      if (response.data.orderData?.status === "COMPLETED" || response.data.isSuccessful) {
        alert("Payment Successful!"); // Or use Toast
        setIsModalOpen(false);
      } else {
        // If backend returns a specific message, show it. Otherwise default fail.
        alert(response.data.message || "Payment Failed. Please fill in all card details correctly.");
      }

    } catch (error) {
      console.error(error);
      const errorMsg = error?.response?.data?.message || "Payment Error. Please fill in all card details correctly.";
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal
      isOpen={isModalOpen}
      contentLabel="Buy DM"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          zIndex: 1000
        },
        content: {
          color: "#fff",
          backgroundColor: "#2c2c2c",
          borderRadius: "10px",
          padding: "20px",
          maxWidth: "600px",
          margin: "50px auto",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        },
      }}
    >
      <div className="bg-transparent">
        <button
          onClick={() => setIsModalOpen(false)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "transparent",
            border: "none",
            fontSize: "20px",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        <h1>Donate Cash</h1>

        {/* Toggle Payment Method */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
          <button
            onClick={() => setPaymentMethod('card')}
            style={{
              flex: 1,
              padding: '10px',
              backgroundColor: paymentMethod === 'card' ? '#3ca151' : 'transparent',
              border: '1px solid #3ca151',
              borderRadius: '5px',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            Card
          </button>
          <button
            onClick={() => setPaymentMethod('paypal')}
            style={{
              flex: 1,
              padding: '10px',
              backgroundColor: paymentMethod === 'paypal' ? '#0070ba' : 'transparent',
              border: '1px solid #0070ba',
              borderRadius: '5px',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            PayPal
          </button>
        </div>

        {/* Amount Input */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Amount ($)</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #555',
              backgroundColor: '#333',
              color: 'white'
            }}
          />
        </div>

        {/* Note Input */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Note (Optional)</label>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #555',
              backgroundColor: '#333',
              color: 'white',
              resize: 'vertical'
            }}
          />
        </div>

        {paymentMethod === 'card' && (
          <form onSubmit={handleCardSubmit}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px' }}>Name on Card</label>
              <input
                type="text"
                required
                value={cardDetails.name}
                onChange={(e) => setCardDetails({ ...cardDetails, name: e.target.value })}
                style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #555', backgroundColor: '#333', color: 'white' }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px' }}>Card Number</label>
              <input
                type="text"
                required
                value={cardDetails.cardNumber}
                onChange={(e) => setCardDetails({ ...cardDetails, cardNumber: e.target.value })}
                style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #555', backgroundColor: '#333', color: 'white' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Expiry (MM/YYYY)</label>
                <input
                  type="text"
                  required
                  placeholder="MM/YYYY"
                  value={cardDetails.expiry}
                  onChange={(e) => setCardDetails({ ...cardDetails, expiry: e.target.value })}
                  style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #555', backgroundColor: '#333', color: 'white' }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>CVV</label>
                <input
                  type="text"
                  required
                  value={cardDetails.cvv}
                  onChange={(e) => setCardDetails({ ...cardDetails, cvv: e.target.value })}
                  style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #555', backgroundColor: '#333', color: 'white' }}
                />
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              {loading ? (
                <BarLoader cssOverride={{ margin: "auto" }} color="#3ca151" />
              ) : (
                <button
                  type="submit"
                  style={{
                    width: '100%',
                    padding: '12px',
                    backgroundColor: '#3ca151',
                    border: 'none',
                    borderRadius: '5px',
                    color: 'white',
                    fontSize: '16px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  Pay with Card
                </button>
              )}
            </div>
          </form>
        )}

        {paymentMethod === 'paypal' && (
          <div id="paypal-container-2B2FXPQHQV2HQ" style={{ marginTop: '20px' }}></div>
        )}

      </div>
    </Modal>
  );
};

export default BuyDM;
